import axios from "axios";
import { BASE_PATH } from "../resources/ApiUrls";
import { authConstants } from "constants/authConstants";
import { LocalStorageManager } from "./LocalStorageManager";

const fetchClient = () => {
  const defaultOptions = {
    baseURL: BASE_PATH,
    headers: {
      "Content-Type": "application/json",
    },
  };

  // CREATE INSTANCE
  let instance = axios.create(defaultOptions);

  instance.interceptors.request.use((config) => {
    const token = LocalStorageManager.getLocalStorageItem(authConstants.MonitoringUserNew)?.tokens.monitoringToken

    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config;
  });
  return instance;
};

export default fetchClient();
